import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { AuditLogEffects } from "./effects/audit-log.effect";
import { auditLogReducer } from "./reducers/audit-log.reducers";

@NgModule({
    imports: [StoreModule.forFeature("audit-log", auditLogReducer), EffectsModule.forFeature([AuditLogEffects])],
    declarations: [],
    providers: [],
})
export class AuditLogStoreModule {}
